// chatbot-admin\ui\client\src\DataCacheContext.js

import {
  createContext,
  useCallback,
  useContext,
  useState,
  useEffect,
} from "react";
import { fetchSecure } from "./utils/utils";

const DataCacheContext = createContext();

export const DataCacheProvider = ({ children }) => {
  const [dataCache, setDataCache] = useState({});

  const initDataCache = useCallback(async (userId) => {
    console.log("in initDataCache - " + userId);
    if (userId && userId.length === 0) return;
    try {
      // const response = await fetchSecure(
      //   "/api/getObjects/agents/WHERE/userId/==/" + userId
      // );
      /*Vik(May 29, 2025): To show name of subagents in integrations */
      // const response = await fetchSecure("/api/getObjects/agents");
      const response = await fetchSecure(
        "/api/getObjects/agents/where/userIds/array-contains/" + userId
      );
      const responseData = await response.json();

      /* Vik(Aug 19, 2025): Ensuring only users created of shared with user agents */
      const usersAgents = responseData.filter(
        (item) => item.userId === userId || item.userIds?.includes(userId)
      );
      const updatedDataCache = { ...dataCache }; // Create a new object to avoid mutating state directly
      updatedDataCache["agents"] = usersAgents;
      const agentObject = {};
      for (const agent of usersAgents) {
        agentObject[agent["id"]] = {
          agentName: agent["agentName"],
          agentType: agent["agentType"],
        };
      }
      updatedDataCache["agentsLookup"] = agentObject;

      // const response1 = await fetchSecure(
      //   "/api/getObjects/integrations/WHERE/userId/==/" + userId
      // );
      /*Vik(May 29, 2025): To show name of integrations in integrations */
      // const response1 = await fetchSecure("/api/getObjects/integrations");
      const response1 = await fetchSecure(
        "/api/getObjects/integrations/where/userIds/array-contains/" + userId
      );
      const responseData1 = await response1.json();

      /* Vik(Aug 19, 2025): Ensuring only users created of shared with user integrations */
      const usersIntegrations = responseData1.filter(
        (item) => item.userId === userId || item.userIds?.includes(userId)
      );
      updatedDataCache["integrations"] = usersIntegrations;
      const integrationObject = {};
      for (const integration of usersIntegrations) {
        integrationObject[integration["id"]] = integration;
      }

      updatedDataCache["integrationsLookup"] = integrationObject;
      setDataCache(updatedDataCache);
    } catch (e) {
      console.log(`Failed to load data cache`);
      console.log(e);
      console.log(e.stack);
    }
  }, []);

  return (
    <DataCacheContext.Provider
      value={{ initDataCache, dataCache, setDataCache }}
    >
      {children}
    </DataCacheContext.Provider>
  );
};

export const useDataCache = () => {
  return useContext(DataCacheContext);
};
